import { Avatar, AvatarProps, Typography } from "@/components/atoms";
import { getAssetUrl } from "@/utils";
import { getInitials } from "./helpers";

interface ClientAvatarProps extends Omit<AvatarProps, "src"> {
  name: string;
  /**
   * Relative CDN image key from the account DTO (e.g. "raw/images/avatar/…"), or null.
   * NOT a full URL — it must go through `getAssetUrl` (image handler) like every other avatar
   * in the app; using it raw as an <img src> resolves against the app origin and 404s.
   */
  avatar?: string | null;
}

/** Avatar that renders the managed account's photo, or their initials on a neutral chip. */
export const ClientAvatar = ({ name, avatar, size = "md", className, ...rest }: ClientAvatarProps) => {
  if (avatar) {
    return (
      <Avatar size={size} src={getAssetUrl(avatar, { height: 120, width: 120, fit: "cover" })} alt={name} className={className} {...rest} />
    );
  }

  return (
    <Avatar size={size} variant="circle" className={`bg-neutral-silver-gray ${className ?? ""}`} {...rest}>
      <Typography variant="action" className="font-semibold text-white">
        {getInitials(name)}
      </Typography>
    </Avatar>
  );
};
